// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 13/12/2023
 */

.Profile_container__Y8aTy {
    display: flex;
    justify-content: center;
}

.Profile_paper__lhCw1 {
    padding: 2rem;
    border-radius: 0.5rem;
    box-shadow: 0px 4px 10px 0px rgba(89, 124, 215, 0.25);
    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);
    width: 100%;
    max-width: 500px;
    margin: 2rem ;
    overflow: auto;
    min-height: 25rem;
    max-width: 40rem;
}

.Profile_addAddressContainer__J7\\+ri {
    padding: 1rem 0;
    border-bottom: 1px solid #5A9BD8;
    display: flex;
    justify-content: space-between;
}

.Profile_addressContainer__oNDs5 {
    padding: 1rem;
    border: 1px solid #5A9BD8;
    border-radius: 0.5rem;
    margin: 1rem 0 0 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.Profile_tabPannel__TXCvJ {
    padding: 0;
}

.Profile_bookingContainer__E4szL {
    padding: 1rem;
    margin: 0;
    border: 1px solid #5A9BD8;
    border-radius: 0.5rem;
    margin: 0.5rem 0 0 0;
    display: flex;
    justify-content: space-between;
}

.Profile_subTitle__Xdc5m {
    font-size: 1rem;
    font-weight: 600;
}

.Profile_details__NHsxs {
    font-size: 0.9rem;
}

.Profile_status__6ZTPK {
    font-size: 0.9rem;
    border: 1px solid #428ace;
    border-radius: 0.5rem;
    background-color: #5A9BD8;
    padding: 0.1rem 0.5rem;
    align-self: flex-end;
}

.Profile_statusMob__Qn6dw {
    display: none;
}

.Profile_resource__Z58-L {
    font-size: 0.9rem;
    border: 1px solid #428ace;
    border-radius: 0.5rem;
    padding: 0.1rem 0.5rem;
    margin-top: 0.5rem;
    width: -moz-fit-content;
    width: fit-content;
}

.Profile_formItem__xI3su{
    margin: 10px 0;
}

.Profile_formText__YJ\\+4Q{
    background: #FFF;
    margin-top: 10px;
}

.Profile_formLabel__rIKk7{
    margin-top: 50px;
    margin-bottom: 8px;
    padding-top: 10rem !important;
    font-weight: 600 !important;
}

.Profile_form__6mZMI{
    display:flex;
    flex-direction: column;
}

.Profile_button__FKbXK{
    border-radius: 0.5rem;
    padding: 0.5rem 2.5rem;
    margin-top: 1rem;
}

.Profile_norequest__J8ulW {
    text-align: center;
    padding-top: 2rem;
}

@media (max-width: 770px) {
    .Profile_status__6ZTPK {
        display: none;
        font-size: 0.9rem;
        border: 1px solid #428ace;
        border-radius: 0.5rem;
        background-color: #5A9BD8;
        padding: 0.1rem 0.5rem;
        align-self: flex-end;
    }
    .Profile_statusMob__Qn6dw {
        display: block;
        font-size: 0.9rem;
        border: 1px solid #428ace;
        border-radius: 0.5rem;
        background-color: #5A9BD8;
        padding: 0.1rem 0.5rem;
        align-self: flex-end;
        margin-top: 1rem;
        align-items: center;
        text-align: center;
    }
    
    .Profile_button__FKbXK {
        height: 36px; 
        font-size: 0.75rem;
        line-height: 1;
      }
  }`, "",{"version":3,"sources":["webpack://./src/Pages/Profile.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;AAEF;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,qDAAqD;IACrD,gGAAgG;IAChG,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,qBAAqB;IACrB,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,yBAAyB;IACzB,qBAAqB;IACrB,oBAAoB;IACpB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,qBAAqB;IACrB,sBAAsB;IACtB,kBAAkB;IAClB,uBAAkB;IAAlB,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,6BAA6B;IAC7B,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI;QACI,aAAa;QACb,iBAAiB;QACjB,yBAAyB;QACzB,qBAAqB;QACrB,yBAAyB;QACzB,sBAAsB;QACtB,oBAAoB;IACxB;IACA;QACI,cAAc;QACd,iBAAiB;QACjB,yBAAyB;QACzB,qBAAqB;QACrB,yBAAyB;QACzB,sBAAsB;QACtB,oBAAoB;QACpB,gBAAgB;QAChB,mBAAmB;QACnB,kBAAkB;IACtB;;IAEA;QACI,YAAY;QACZ,kBAAkB;QAClB,cAAc;MAChB;EACJ","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 13/12/2023\r\n */\r\n\r\n.container {\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n.paper {\r\n    padding: 2rem;\r\n    border-radius: 0.5rem;\r\n    box-shadow: 0px 4px 10px 0px rgba(89, 124, 215, 0.25);\r\n    background: linear-gradient(91deg, rgba(90, 155, 216, 0.1) 23.22%, rgba(90, 155, 216, 0) 99.28%);\r\n    width: 100%;\r\n    max-width: 500px;\r\n    margin: 2rem ;\r\n    overflow: auto;\r\n    min-height: 25rem;\r\n    max-width: 40rem;\r\n}\r\n\r\n.addAddressContainer {\r\n    padding: 1rem 0;\r\n    border-bottom: 1px solid #5A9BD8;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.addressContainer {\r\n    padding: 1rem;\r\n    border: 1px solid #5A9BD8;\r\n    border-radius: 0.5rem;\r\n    margin: 1rem 0 0 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n}\r\n\r\n.tabPannel {\r\n    padding: 0;\r\n}\r\n\r\n.bookingContainer {\r\n    padding: 1rem;\r\n    margin: 0;\r\n    border: 1px solid #5A9BD8;\r\n    border-radius: 0.5rem;\r\n    margin: 0.5rem 0 0 0;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.subTitle {\r\n    font-size: 1rem;\r\n    font-weight: 600;\r\n}\r\n\r\n.details {\r\n    font-size: 0.9rem;\r\n}\r\n\r\n.status {\r\n    font-size: 0.9rem;\r\n    border: 1px solid #428ace;\r\n    border-radius: 0.5rem;\r\n    background-color: #5A9BD8;\r\n    padding: 0.1rem 0.5rem;\r\n    align-self: flex-end;\r\n}\r\n\r\n.statusMob {\r\n    display: none;\r\n}\r\n\r\n.resource {\r\n    font-size: 0.9rem;\r\n    border: 1px solid #428ace;\r\n    border-radius: 0.5rem;\r\n    padding: 0.1rem 0.5rem;\r\n    margin-top: 0.5rem;\r\n    width: fit-content;\r\n}\r\n\r\n.formItem{\r\n    margin: 10px 0;\r\n}\r\n\r\n.formText{\r\n    background: #FFF;\r\n    margin-top: 10px;\r\n}\r\n\r\n.formLabel{\r\n    margin-top: 50px;\r\n    margin-bottom: 8px;\r\n    padding-top: 10rem !important;\r\n    font-weight: 600 !important;\r\n}\r\n\r\n.form{\r\n    display:flex;\r\n    flex-direction: column;\r\n}\r\n\r\n.button{\r\n    border-radius: 0.5rem;\r\n    padding: 0.5rem 2.5rem;\r\n    margin-top: 1rem;\r\n}\r\n\r\n.norequest {\r\n    text-align: center;\r\n    padding-top: 2rem;\r\n}\r\n\r\n@media (max-width: 770px) {\r\n    .status {\r\n        display: none;\r\n        font-size: 0.9rem;\r\n        border: 1px solid #428ace;\r\n        border-radius: 0.5rem;\r\n        background-color: #5A9BD8;\r\n        padding: 0.1rem 0.5rem;\r\n        align-self: flex-end;\r\n    }\r\n    .statusMob {\r\n        display: block;\r\n        font-size: 0.9rem;\r\n        border: 1px solid #428ace;\r\n        border-radius: 0.5rem;\r\n        background-color: #5A9BD8;\r\n        padding: 0.1rem 0.5rem;\r\n        align-self: flex-end;\r\n        margin-top: 1rem;\r\n        align-items: center;\r\n        text-align: center;\r\n    }\r\n    \r\n    .button {\r\n        height: 36px; \r\n        font-size: 0.75rem;\r\n        line-height: 1;\r\n      }\r\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Profile_container__Y8aTy`,
	"paper": `Profile_paper__lhCw1`,
	"addAddressContainer": `Profile_addAddressContainer__J7+ri`,
	"addressContainer": `Profile_addressContainer__oNDs5`,
	"tabPannel": `Profile_tabPannel__TXCvJ`,
	"bookingContainer": `Profile_bookingContainer__E4szL`,
	"subTitle": `Profile_subTitle__Xdc5m`,
	"details": `Profile_details__NHsxs`,
	"status": `Profile_status__6ZTPK`,
	"statusMob": `Profile_statusMob__Qn6dw`,
	"resource": `Profile_resource__Z58-L`,
	"formItem": `Profile_formItem__xI3su`,
	"formText": `Profile_formText__YJ+4Q`,
	"formLabel": `Profile_formLabel__rIKk7`,
	"form": `Profile_form__6mZMI`,
	"button": `Profile_button__FKbXK`,
	"norequest": `Profile_norequest__J8ulW`
};
export default ___CSS_LOADER_EXPORT___;
